import { createBrowserHistory } from 'history'

import { isServerSide } from '@emico/ssr-utils'
import { findActiveStoreView, getStoreViews } from '@emico/storeviews'

const basename = findActiveStoreView(getStoreViews())?.basename

const history = isServerSide()
  ? undefined
  : createBrowserHistory({
      basename,
    })

export default history
